/** Lista de repeticiones guardadas en una prueba (o una sola rep. legacy). */
export function listarRepsPrueba(prueba) {
    if (Array.isArray(prueba?.reps) && prueba.reps.length > 0) {
        return prueba.reps.map((r, i) => ({
            index: i,
            key: r.key ?? i,
            label: r.label ?? `Rep. ${i + 1}`,
        }));
    }
    return [{ index: 0, key: 0, label: "Rep. 1" }];
}

/** Datos de la prueba para la repetición seleccionada (compatible con pruebas antiguas). */
export function pruebaConRep(prueba, repIndex = 0) {
    if (!prueba) return null;

    const reps = prueba.reps;
    if (Array.isArray(reps) && reps.length > 0) {
        const idx = Math.max(0, Math.min(repIndex, reps.length - 1));
        const rep = reps[idx];
        return {
            ...prueba,
            sistema_de_pesos_y_tiempos: rep.sistema_de_pesos_y_tiempos ?? [],
            fases: rep.fases ?? [],
            parametros: rep.parametros ?? [],
            datos: rep.datos ?? prueba.datos,
            datos_brutos: rep.datos_brutos ?? prueba.datos_brutos,
            inicioFases: rep.inicioFases ?? prueba.inicioFases,
            finFases: rep.finFases ?? prueba.finFases,
            _repIndex: idx,
            _repLabel: rep.label ?? `Rep. ${idx + 1}`,
            reps,
        };
    }

    return { ...prueba, _repIndex: 0, _repLabel: "Rep. 1" };
}

export function pruebaTieneVariasReps(prueba) {
    return cantidadRepsPrueba(prueba) > 1;
}

/** Número de repeticiones guardadas (pruebas antiguas sin `reps` cuentan como 1). */
export function cantidadRepsPrueba(prueba) {
    if (Array.isArray(prueba?.reps) && prueba.reps.length > 0) {
        return prueba.reps.length;
    }
    if (typeof prueba?.cantidadReps === "number" && prueba.cantidadReps > 0) {
        return prueba.cantidadReps;
    }
    return 1;
}
